import { memo } from "react";
import { createPortal } from "react-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

/* ─────────────────────────────────────────────
   Inject CSS once at module level
───────────────────────────────────────────── */
(function injectOnce() {
  if (typeof document === "undefined") return;
  if (document.getElementById("lm-styles")) return;
  const tag = document.createElement("style");
  tag.id = "lm-styles";
  tag.textContent = `
    .lm-backdrop {
      position: fixed;
      inset: 0;
      z-index: 99998;
      background: rgba(6, 10, 30, 0.62);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      pointer-events: none;
      animation: lmFadeIn 0.2s ease forwards;
    }
    @keyframes lmFadeIn { from { opacity: 0; } to { opacity: 1; } }

    .lm-overlay {
      position: fixed;
      inset: 0;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      padding: 20px;
      box-sizing: border-box;
    }

    .lm-card {
      pointer-events: all;
      width: 100%;
      max-width: 460px;
      background: #fff;
      border-radius: 22px;
      overflow: hidden;
      box-shadow: 0 32px 80px rgba(0,0,0,0.36);
      animation: lmSlideUp 0.28s cubic-bezier(0.34,1.56,0.64,1) forwards;
    }
    @keyframes lmSlideUp {
      from { opacity: 0; transform: translateY(28px) scale(0.96); }
      to   { opacity: 1; transform: translateY(0) scale(1); }
    }

    .lm-header {
      position: relative;
      background: linear-gradient(135deg, #1a2e80 0%, #2541b2 100%);
      padding: 24px 28px 20px;
    }
    .lm-close {
      position: absolute;
      top: 14px; right: 14px;
      width: 30px; height: 30px;
      border-radius: 50%;
      border: none;
      background: rgba(255,255,255,0.2);
      color: #fff;
      font-size: 20px;
      font-family: Arial, sans-serif;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      transition: background 0.18s;
      z-index: 2;
    }
    .lm-close:hover { background: rgba(255,255,255,0.36); }
    .lm-brand-row {
      display: flex; align-items: center;
      gap: 10px; margin-bottom: 14px; padding-right: 36px;
    }
    .lm-logo {
      width: 36px; height: 36px;
      border-radius: 8px; background: #fff;
      padding: 3px; object-fit: contain; flex-shrink: 0;
    }
    .lm-brand-name { font-size: 16px; font-weight: 700; color: #fff; letter-spacing: 0.3px; }
    .lm-title      { font-size: 23px; font-weight: 700; color: #fff; margin: 0 0 4px; }
    .lm-subtitle   { font-size: 13px; color: rgba(255,255,255,0.72); margin: 0; }

    .lm-body {
      padding: 24px 28px 26px;
      display: flex; flex-direction: column; gap: 15px;
      background: #fff;
    }
    .lm-field { display: flex; flex-direction: column; gap: 5px; }
    .lm-field label {
      font-size: 11px; font-weight: 700;
      color: #555; text-transform: uppercase; letter-spacing: 0.7px;
    }
    .lm-input-wrap { position: relative; display: flex; align-items: center; }
    .lm-icon {
      position: absolute; left: 12px;
      color: #b0b8d0; display: flex; align-items: center; pointer-events: none;
    }
    .lm-input-wrap input {
      width: 100%;
      padding: 11px 14px 11px 38px;
      border: 1.5px solid #dde2f0;
      border-radius: 10px;
      font-size: 14px; color: #1a1a2e;
      background: #f5f7ff; outline: none;
      transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
      box-sizing: border-box;
    }
    .lm-input-wrap input::placeholder { color: #b0b8d0; }
    .lm-input-wrap input:focus {
      border-color: #2541b2; background: #fff;
      box-shadow: 0 0 0 3px rgba(37,65,178,0.11);
    }
    .lm-input-wrap input:disabled {
      background: #edf0f8; color: #8a90a8;
      cursor: not-allowed; border-color: #e4e8f4;
    }

    .lm-otp-input {
      width: 100%; padding: 12px 10px;
      border: 1.5px solid #dde2f0; border-radius: 10px;
      font-size: 22px; letter-spacing: 12px;
      text-align: center; color: #1a1a2e;
      background: #f5f7ff; outline: none;
      transition: border-color 0.18s, box-shadow 0.18s, background 0.18s;
      box-sizing: border-box;
    }
    .lm-otp-input::placeholder { letter-spacing: 2px; font-size: 14px; color: #b0b8d0; }
    .lm-otp-input:focus {
      border-color: #2541b2; background: #fff;
      box-shadow: 0 0 0 3px rgba(37,65,178,0.11);
    }

    .lm-timer { font-size: 13px; color: #888; text-align: center; margin: -3px 0; }
    .lm-timer b { color: #2541b2; }

    .lm-submit-btn {
      width: 100%; padding: 13px;
      background: linear-gradient(135deg, #1a2e80, #2541b2);
      color: #fff; border: none; border-radius: 10px;
      font-size: 15px; font-weight: 600;
      cursor: pointer; letter-spacing: 0.4px;
      transition: opacity 0.18s, transform 0.14s;
    }
    .lm-submit-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
    .lm-submit-btn:active:not(:disabled) { opacity: 0.85; transform: translateY(0); }
    .lm-submit-btn:disabled { opacity: 0.38; cursor: not-allowed; }

    .lm-resend-btn {
      width: 100%; padding: 11px;
      background: transparent;
      border: 1.5px solid #2541b2; border-radius: 10px;
      color: #2541b2; font-size: 14px; font-weight: 600;
      cursor: pointer;
      transition: background 0.18s, color 0.18s;
    }
    .lm-resend-btn:hover { background: #2541b2; color: #fff; }
    .lm-resend-btn:active { background: #1a2e80; border-color: #1a2e80; color: #fff; }

    .lm-trust {
      display: flex; align-items: center; justify-content: center;
      gap: 6px; font-size: 12px; color: #aaa; margin: 0;
    }

    .swal2-container { z-index: 999999 !important; }

    @media (max-width: 500px) {
      .lm-overlay  { padding: 12px; }
      .lm-card     { border-radius: 16px; }
      .lm-header   { padding: 20px 16px 16px; }
      .lm-body     { padding: 18px 16px 20px; gap: 13px; }
      .lm-title    { font-size: 20px; }
    }
  `;
  document.head.appendChild(tag);
})();

/* ─────────────────────────────────────────────
   Backdrop — isolated portal, never re-renders
───────────────────────────────────────────── */
export const StaticBackdrop = memo(function StaticBackdrop() {
  return createPortal(<div className="lm-backdrop" />, document.body);
});

/* ─────────────────────────────────────────────
   LoginModal
───────────────────────────────────────────── */
const LoginModal = memo(function LoginModal({
  showOtp,
  userForm,
  setUserForm,
  otp,
  setOtp,
  seconds,
  onClose,
  onSendOtp,
  onVerifyOtp,
  onResend,
}) {
  return createPortal(
    <div className="lm-overlay">
      <div className="lm-card" onClick={(e) => e.stopPropagation()}>

        {/* HEADER */}
        <div className="lm-header">
          
          <div className="lm-brand-row">
            <button className="lm-close" onClick={onClose}>
  ×
</button>
            
          </div>
          <h3 className="lm-title">Welcome back</h3>
          <p className="lm-subtitle">Sign in to access your courses</p>
        </div>

        {/* BODY */}
        <div className="lm-body">

          {/* Name */}
          <div className="lm-field">
            <label>Full Name</label>
            <div className="lm-input-wrap">
              <span className="lm-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
              </span>
              <input
                type="text"
                placeholder="e.g. Ravi Kumar"
                disabled={showOtp}
                value={userForm.name}
                onChange={(e) => {
                  const value = e.target.value
                    .replace(/[^A-Za-z ]/g, "")
                    .replace(/\s+/g, " ")
                    .replace(/^\s+/, "");
                  setUserForm((prev) => ({ ...prev, name: value }));
                }}
              />
            </div>
          </div>

          {/* Phone */}
          <div className="lm-field">
            <label>Phone Number</label>
            <PhoneInput
              country={"in"}
              enableSearch={true}
              disabled={showOtp}
              value={userForm.phone}
              inputStyle={{
  width: "100%",
  height: "48px",
  border: "1px solid #dde2f0",
  borderRadius: "10px",
  background: "#f5f7ff",
  paddingLeft: "90px",
  fontSize: "14px",
}}
              onChange={(value, country) => {
                setUserForm((prev) => ({
                  ...prev,
                  countryCode: "+" + country.dialCode,
                  phone: value,
                }));
              }}
            />
          </div>

          {/* Email */}
          <div className="lm-field">
            <label>Email Address</label>
            <div className="lm-input-wrap">
              <span className="lm-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="16" x="2" y="4" rx="2"/>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                </svg>
              </span>
              <input
                type="email"
                placeholder="you@example.com"
                disabled={showOtp}
                value={userForm.email}
                onChange={(e) => {
                  const value = e.target.value.replace(/\s/g, "").toLowerCase();
                  setUserForm((prev) => ({ ...prev, email: value }));
                }}
              />
            </div>
          </div>

          {/* OTP or Send button */}
          {!showOtp ? (
            <button className="lm-submit-btn" onClick={onSendOtp}>
              Send OTP
            </button>
          ) : (
            <>
              <div className="lm-field">
                <label>Email Verification OTP</label>
               <input
  type="text"
  inputMode="numeric"
  maxLength={6}
  className="lm-otp-input"
  placeholder="Enter 6-digit OTP"
  value={otp}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setOtp(value);
  }}
  onPaste={(e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);

    setOtp(pasted);
  }}
/>
              </div>
              <p className="lm-timer">
                OTP expires in:{" "}
                <b>
                  {Math.floor(seconds / 60)}:{String(seconds % 60).padStart(2, "0")}
                </b>
              </p>
              <button
                className="lm-submit-btn"
                disabled={otp.length !== 6 || seconds === 0}
                onClick={onVerifyOtp}
              >
                Verify &amp; Continue
              </button>
              <button className="lm-resend-btn" onClick={onResend}>
                Resend OTP
              </button>
            </>
          )}

          <p className="lm-trust">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            Your information is secure and never shared
          </p>
        </div>
      </div>
    </div>,
    document.body
  );
});

export default LoginModal;
